import Resource from '@/plugins/sdk/Resource'
import { STRING, BOOLEAN, UUID, ITEM } from '@/plugins/sdk/fields'
import Carrier from '@/plugins/sdk/resources/Carrier'

export default class extends Resource {
  static name = 'carrier_contact'

  static get fields () {
    return {
      id: new UUID(),
      carriercont_name: new STRING(),
      carriercont_title: new STRING(),
      carriercont_location: new STRING(),
      carriercont_phone: new STRING(),
      carriercont_mobile: new STRING(),
      carriercont_email: new STRING(),
      carriercont_notes: new STRING(),
      carriercont_incpickups: new BOOLEAN(),
      carrier: new ITEM(Carrier)
    }
  }
}
